import { IsNotEmpty, IsString } from 'class-validator';
import { ProjetoEditarFormDataDto } from './projeto-editar-form-data.dto';
import { ProjetoTipo } from './projeto-tipo.enum';

export class ProjetoCriarFormDataDto extends ProjetoEditarFormDataDto {
  @IsString()
  @IsNotEmpty()
  tipo: ProjetoTipo
}
